import React from "react";
import FarmCard from "../../../../components/farm/FarmCard";
import S from "../../../../assets/stylesheets/experience/sections/ExperienceFarmCard.module.css";

export default function ExperienceFarmCard({ farm, onFarmClick }) {
  if (!farm) return null;

  return (
    <section className={S["exp-farm-section"]}>
      <h2 className={S["exp-section-title"]}>About the farm</h2>
      <div className={S["exp-farm-cards-row"]}>
        <div className={S["exp-farm-card-wrapper"]}>
          <FarmCard farm={farm} index={0} onClick={onFarmClick} />
        </div>
      </div>
    </section>
  );
}
